import React, { Component } from 'react'
import { connect } from 'react-redux'
import logo from '../../assets/img/logoHeader.svg'
import './endpage.css'

class EndPage extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  removePaymentSearch() {
    const url = new URL(window.location.href)
    url.searchParams.delete('payment')

    // Actualizar la URL sin recargar la página
    window.history.replaceState({}, '', url.toString())
  }
  reload() {
    this.removePaymentSearch()
    localStorage.removeItem('dataCalc')
    localStorage.removeItem('venc')
    localStorage.removeItem('dateCalc')
    window.location.reload()
  }
  goToResults() {
    this.removePaymentSearch()
    this.props.changePage(10)
  }
  render() {
    return (
      <div className="endpage-container">
        <div className="endpage-content">
          {/* Logo centrado con animación sutil */}
          <div className="logo-container">
            <img className="logo-image" src={logo} alt="fullmusculo-logo" />
          </div>

          {/* Título principal con énfasis */}
          <div className="success-title">
            <h1 className="title-text">
              <span className="title-exclamation">¡</span>
              EXCELENTE
              <span className="title-exclamation">!</span>
            </h1>
            <div className="title-decoration"></div>
          </div>

          {/* Mensaje de confirmación */}
          <div className="confirmation-message">
            <p className="message-paragraph highlight">
              Estamos generando tu plan de alimentación 100% personalizado; en
              las próximas horas estará llegando a tu correo electrónico.
            </p>
            <p className="message-paragraph">
              Si en las próximas 48 horas aún no ha llegado, puedes volver aquí
              o ponerte en contacto con nosotros.
            </p>
            <p className="thank-you-message">
              Gracias por confiar en{' '}
              <span className="brand-emphasis">Fullmusculo</span>
            </p>
          </div>

          {/* Acciones y información adicional */}
          <div className="actions-section">
            <div className="actions-container">
              {/* Botones de acción */}
              <div className="action-buttons">
                <button
                  className="action-btn primary-btn"
                  onClick={() => this.goToResults()}
                >
                  <span className="btn-icon">←</span>
                  Volver a los resultados
                </button>
                <button
                  className="action-btn secondary-btn"
                  onClick={() => this.reload()}
                >
                  <span className="btn-icon">↻</span>
                  Volver a calcular
                </button>
              </div>

              {/* Información adicional */}
              <div className="additional-info">
                <div className="info-card">
                  <div className="info-icon">📧</div>
                  <p className="info-text">
                    <span className="info-highlight">
                      No olvides revisar siempre la bandeja de Spam o correo no
                      deseado
                    </span>
                    , pudiera darse el caso de que nuestros emails te estén
                    llegando allí.
                  </p>
                </div>

                <div className="info-card">
                  <div className="info-icon">💬</div>
                  <p className="info-text">
                    En caso de tener alguna duda o consulta puedes escribirnos
                    directamente a nuestro email{' '}
                    <a
                      href="mailto:info@fullmusculo.com"
                      className="email-link"
                    >
                      info@fullmusculo.com
                    </a>
                    .
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({})
const mapDispatchToProps = (dispatch) => ({
  changePage(page) {
    dispatch({
      type: 'CHANGE_PAGE',
      page: page,
    })
  },
})
export default connect(mapStateToProps, mapDispatchToProps)(EndPage)
